import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
}

const Input: React.FC<InputProps> = (props) => {
    const { label, id, className } = props;
    return (
        <div className="form-group">
            <label htmlFor={id}>{label}</label>
            <input {...props} className={`form-control ${className}`} />
        </div>
    );
};

export default Input;
